import { parseParamsForURL } from 'services/utils/urlParams';
import http from 'services/utils/http';

const apiName = 'countries';
const baseUrl = '/partners/utils/countries.json';

const formatData = (data) => {
    const res = [];
    const values = Object.values(data.countries);
    const headers = Object.keys(data.countries);
    for (let i = 0; i < values.length; i++) {
        res.push({
            displayText: headers[i],
            isHeader: true
        });
        // eslint-disable-next-line no-restricted-syntax
        for (const code in values[i]) {
            // eslint-disable-next-line no-prototype-builtins
            if (values[i].hasOwnProperty(code)) {
                res.push({
                    id: code,
                    flag: code,
                    title: values[i][code],
                    displayText: values[i][code]
                });
            }
        }
    }

    return res;
};
export default {
    namespaced: true,
    state: {
        list: null,
        error: undefined,
        raw: undefined,
        loading: true
    },
    mutations: {
        setLoading(state, isLoading) {
            state.loading = isLoading;
        },
        setCountries(state, { raw, formatted }) {
            state.list = formatted;
            state.raw = raw;
            state.loading = false;
        },
        setError(state, error) {
            state.error = error;
        }
    },
    actions: {
        async fetch({ commit, rootGetters }, {
            refresh = false,
            filters = {}
        } = {}) {
            const params = parseParamsForURL(filters);
            const apiUrl = `${baseUrl}?${params}`;

            if (!refresh) {
                const cachedResult = rootGetters['cache/getFromCache'](apiName, apiUrl);
                if (cachedResult) {
                    commit('setError', undefined);
                    commit('setCountries', cachedResult);
                    return cachedResult;
                }
            }

            let formatted;
            let raw;
            try {
                commit('setLoading', true);
                const resData = await http.get(apiUrl, false);
                raw = resData.data.countries;
                formatted = formatData(resData.data);
                const countries = { raw, formatted };
                commit('cache/set', {
                    api: apiName,
                    req: apiUrl,
                    data: countries
                }, { root: true });
                commit('setCountries', countries);
                commit('setError', undefined);
            } catch (err) {
                commit('setError', err.message);
            } finally {
                commit('setLoading', false);
            }

            return { raw, formatted };
        }
    },
    getters: {
        getCountriesState: (state) => state.list,
        getCountriesLoading: (state) => state.loading
    }
};
